"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDidUpdateEffect = void 0;

var react_1 = require("react");

function useDidUpdateEffect(effect, deps, isLayout) {
  var didMountRef = (0, react_1.useRef)(false);

  var callback = function callback() {
    if (!didMountRef.current) {
      didMountRef.current = true;
    } else {
      return effect();
    }
  };

  if (isLayout) {
    (0, react_1.useLayoutEffect)(callback, deps);
  } else {
    (0, react_1.useEffect)(callback, deps);
  }
}

exports.useDidUpdateEffect = useDidUpdateEffect;